/* global hUrl */
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-ppv')) {
  pagePpv()
}
function pagePpv() {
  //  ##  ###    ###    ###     ####    #####
  //  ##  ## #  # ##   ## ##   ##       ##
  //  ##  ##  ##  ##  ##   ##  ##  ###  #####
  //  ##  ##      ##  #######  ##   ##  ##
  //  ##  ##      ##  ##   ##   ####    #####
  if (document.getElementById('imageSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('imageSlide')
    const sliderName = 'imageSlide'
    const imageSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（imageSlideSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 50, // アニメ速度
      loop: false, // ループ
      // autoHeight: true, // スライドごとに高さを変動させる
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })

    // let lastSlide = null
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.closest('.js-slideShift')) {
        const slide = parseInt(e.target.dataset.slide, 10)
        // if (lastSlide === slide) {
        //   return
        // }
        imageSlideSwiper.slideTo(slide - 1)
        // imageSlideSwiper.slideNext()
        // lastSlide = slide
      }
      if (e.target.closest('.swiper-slide')) {
        const next = imageSlideSwiper.slideNext()
        if (!next) {
          window.modalClose() // 最終スライドでモーダルを閉じる
        }
      }
    })
  }
}
